var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conference_frame",attrs:{"id":"meetingConferenceIframeId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }